import { api } from "@/lib/api/client";

import type { FamilyDirectory, FamilyResult } from "./types";

const EMPTY: FamilyResult = { phone: "", count: 0, members: [] };

export const familyApi = {
  /** Famille de la fiche patient courante (téléphone résolu côté serveur). */
  forPatient: async (id: string): Promise<FamilyResult> => {
    const { data } = await api.get<FamilyResult>(`/patients/${id}/family/`);
    return data;
  },
  /** Famille de la fiche client courante. */
  forClient: async (id: string): Promise<FamilyResult> => {
    const { data } = await api.get<FamilyResult>(`/clients/${id}/family/`);
    return data;
  },
  /** Recherche transverse (patients + clients) par numéro de téléphone. */
  byPhone: async (phone: string): Promise<FamilyResult> => {
    const trimmed = phone.trim();
    if (!trimmed) return EMPTY;
    const { data } = await api.get<FamilyResult>("/clients/family/", {
      params: { phone: trimmed },
    });
    return data;
  },
  /** Répertoire paginé des foyers, cherchable par nom (sans connaître le numéro). */
  list: async (params: {
    search?: string;
    page?: number;
    page_size?: number;
  }): Promise<FamilyDirectory> => {
    const { data } = await api.get<FamilyDirectory>("/clients/families/", { params });
    return data;
  },
};
